import React, {useEffect, useState} from 'react';
import { useSearchParams } from 'react-router-dom';
import { oneKlicks } from '../../../SDK/oneclick';
import PageSerch from '../SerchDocters/Components/PageSerch';
import DynamicBreadcrumbs from '../../../Uitiles/DynamicBreadcrumbs';
import { decryptId, testEncoding } from '../../../services/apiService';
import ImageShow from '../../../Uitiles/ImageShow';


const PharmacyDetailes = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id'); // using http://localhost:3000/pharmacy?id=MW1lZGR5bGlzdA==
    const [pharmacy, setPharmacy] = useState(null);
    const [loading, setLoading] = useState(true);
    const [decodedId, setDecodedId] = useState("");

    useEffect(() => {
        console.log('Raw ID from URL:', id);
        
    }, [id]);

    useEffect(() => {
        console.log('Decoded ID:', decodedId);
        if ( id !== null) {
            const decoded = decryptId(id);
            console.log('Decoded ID live:', decoded);
            setDecodedId(decoded);
            if (decoded) {
                getPharmacyDetailes(decoded);
            } else {
                setLoading(false);
            }
        } else {
            console.log('Decoded ID live:', decodedId);
            console.log('No ID found');
            setLoading(false);
        }
    }, []);

    const getPharmacyDetailes = async (pharmacyId) => {
        try {
            const tableSchema = "";
            const tableName = "pharmacies";
            const conditions = {
                id: pharmacyId
            };
            const orderBy = "id DESC";
            const search = {};
            const pagination = {};
            const margedata = [];
            const range = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata)
            console.log('getPharmacyDetailes response', response);
            if (response && response.data && response.data.length > 0) {
                setPharmacy(response.data[0]);
            }
        } catch (error) {
            console.error('Error getting pharmacy detailes:', error);
        } finally {
            setLoading(false);
        }
    }



  return (
    <>
    <PageSerch />
    <DynamicBreadcrumbs />

    {loading ? (
        <div className="container" >
            <div className="dc-haslayout page-data dc-parent-section dc-enabled">
                <div className="main-page-wrapper">
                    <div className="dokan-store-wrap layout-left">
                        <div id="dokan-secondary" className="dokan-store-sidebar" role="complementary">
                            <div className="dokan-widget-area widget-collapse">
                                <div>Loading pharmacy details...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : decodedId === "" ? (
        <main id="dc-main" className="">    
          <div
            className="container"
            style={{
              background: '#dadce1',
              borderRadius: '11px',
              height: '200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '40px',
              marginBottom: '70px'
            }}
          >
            <div className="dc-haslayout page-data dc-parent-section dc-enabled" style={{ width: '100%' }}>
              <div className="col-md-12">
                <div className="col-md-12">
                  <div id="dokan-secondary" className="col-md-12" role="complementary">
                    <div className="col-md-12">
                      <div style={{ color: '#b71c1c', fontWeight: 'bold', fontSize: '2.0rem', textAlign: 'center' }}>
                        Invalid pharmacy ID or pharmacy not found.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        
    ) : (
        <main id="dc-main" className="">
        <div className="container">
            <div className="dc-haslayout page-data dc-parent-section dc-enabled">
                <div className="main-page-wrapper">
                    <div className="dokan-store-wrap layout-left">
                        <div id="dokan-secondary" className="dokan-store-sidebar" role="complementary">
                            <div className="dokan-widget-area widget-collapse">
                            <aside id="search-3" className="widget dokan-store-widget widget_search">
                                <form className="dc-formtheme dc-formsearch" method="get" role="search" action="//amentotech.com/projects/doctreat/">
                                <fieldset>
                                    <div className="form-group">
                                    <input type="search" name="s" value="" className="form-control" placeholder="Searching might help" />
                                    <button type="submit" className="dc-searchgbtn">
                                        <i className="fa fa-search"></i>
                                    </button>
                                    </div>
                                </fieldset>
                                </form>
                            </aside>
                            
                            <aside id="categories-4" className="widget dokan-store-widget widget_categories">
                                <h3 className="widget-title">Categories</h3>
                                <ul>
                                <li className="cat-item cat-item-18">
                                    <a href="//amentotech.com/projects/doctreat/category/anesthesiology/">Anesthesiology</a>
                                </li>
                                <li className="cat-item cat-item-19">
                                    <a href="//amentotech.com/projects/doctreat/category/dermatology/">Dermatology</a>
                                </li>
                                <li className="cat-item cat-item-20">
                                    <a href="//amentotech.com/projects/doctreat/category/diagnostic-radiology/">Diagnostic radiology</a>
                                </li>
                                <li className="cat-item cat-item-21">
                                    <a href="//amentotech.com/projects/doctreat/category/emergency-medicine/">Emergency medicine</a>
                                </li>
                                <li className="cat-item cat-item-22">
                                    <a href="//amentotech.com/projects/doctreat/category/family-medicine/">Family medicine</a>
                                </li>
                                </ul>
                            </aside>
                            
                            <aside id="search-2" className="widget dokan-store-widget widget_search">
                                <form className="dc-formtheme dc-formsearch" method="get" role="search" action="//amentotech.com/projects/doctreat/">
                                <fieldset>
                                    <div className="form-group">
                                    <input type="search" name="s" value="" className="form-control" placeholder="Searching might help" />
                                    <button type="submit" className="dc-searchgbtn">
                                        <i className="fa fa-search"></i>
                                    </button>
                                    </div>
                                </fieldset>
                                </form>
                            </aside>
                            
                            <aside id="categories-2" className="widget dokan-store-widget widget_categories">
                                <h3 className="widget-title">Categories</h3>
                                <ul>
                                <li className="cat-item cat-item-18">
                                    <a href="//amentotech.com/projects/doctreat/category/anesthesiology/">Anesthesiology</a>
                                </li>
                                <li className="cat-item cat-item-19">
                                    <a href="//amentotech.com/projects/doctreat/category/dermatology/">Dermatology</a>
                                </li>
                                <li className="cat-item cat-item-20">
                                    <a href="//amentotech.com/projects/doctreat/category/diagnostic-radiology/">Diagnostic radiology</a>
                                </li>
                                <li className="cat-item cat-item-21">
                                    <a href="//amentotech.com/projects/doctreat/category/emergency-medicine/">Emergency medicine</a>
                                </li>
                                <li className="cat-item cat-item-22">
                                    <a href="//amentotech.com/projects/doctreat/category/family-medicine/">Family medicine</a>
                                </li>
                                </ul>
                            </aside>
                            </div>
                        </div>

                        <div id="dokan-primary" className="dokan-single-store">
                            <div id="dokan-content" className="store-page-wrap woocommerce" role="main">
                            <div className="dokan-profile-frame-wrapper">
                                <div className="profile-frame">
                                <div className="profile-info-box profile-layout-layout1">
                                    {pharmacy.bannerurl ? (
                                        <ImageShow
                                            url={pharmacy.bannerurl}
                                            height={300}
                                            width={0}
                                            style={{borderRadius: '10px'}}
                                            alt="Laboratorio"
                                            title="Laboratorio"
                                            className="profile-info-img"
                                        />
                                    ) : (
                                        <img 
                                            src={pharmacy.banner || "//amentotech.com/projects/doctreat/wp-content/uploads/2021/08/cropped-cropped-online-flyer-template-featuring-coronavirus-prevention-tips-1676e-2392.png"} 
                                            alt="Laboratorio" 
                                            title="Laboratorio" 
                                            className="profile-info-img" 
                                        />
                                    )}
                                    
                                    <div className="profile-info-summery-wrapper dokan-clearfix">
                                    <div className="profile-info-summery" style={{marginBottom: '20px'}}>
                                        <div className="profile-info-head">
                                        <div className="profile-img profile-img-square">
                                            {pharmacy.photourl ? (
                                                <ImageShow
                                                    url={pharmacy.photourl}
                                                    height={150}
                                                    width={150}
                                                    alt="Laboratorio"
                                                    title="Laboratorio"
                                                    className="profile-info-img"
                                                />
                                            ) : (
                                                <img 
                                                    src={pharmacy.photo || "//amentotech.com/projects/doctreat/wp-content/uploads/2021/08/cropped-cropped-online-flyer-template-featuring-coronavirus-prevention-tips-1676e-2392.png"} 
                                                    alt="Laboratorio" 
                                                    title="Laboratorio" 
                                                    className="profile-info-img" 
                                                />
                                            )}
                                        </div>
                                        </div>

                                        <div className="profile-info">
                                        <h1 className="store-name">{pharmacy.name}</h1>
                                        
                                        <ul className="dokan-store-info">
                                            <li className="dokan-store-address">
                                            <i className="fas fa-map-marker-alt"></i>
                                            <span className="street_1 street_2">{pharmacy.address}</span>
                                            </li>
                                            
                                            <li className="dokan-store-email">
                                            <i className="far fa-envelope"></i>
                                            <a href={`mailto:${pharmacy.email}`}>{pharmacy.email}</a>
                                            </li>
                                            
                                            <li className="dokan-store-rating">
                                            <i className="fas fa-star"></i>
                                            {pharmacy.rating}
                                            </li>

                                            {/* pharmacy.opening_hours is a json string  [{"0":"n","week":"Sunday","open":"00:00","close":"00:00"},{"0":"u","week":"Monday","open":"00:00","close":"00:00"},{"0":"l","week":"Tuesday","open":"00:00","close":"00:00"},{"0":"l","week":"Wednesday","open":"00:00","close":"00:00"},{"week":"Thursday","open":"00:00","close":"00:00"},{"week":"Friday","open":"00:00","close":"00:00"},{"week":"Saturday","open":"00:00","close":"00:00"}] */}
                                            
                                            <li className="dokan-store-open-close">
                                                <i className="fas fa-shopping-cart"></i>
                                                <div className="store-open-close-notice">
                                                    <span className="store-notice">Timing</span>
                                                    <span className="fas fa-angle-down"></span>
                                                    <div id="vendor-store-times">
                                                        <div className="store-times-heading">
                                                            <i className="fas fa-calendar-day"></i>
                                                            <h4>Weekly Store Timing</h4>
                                                        </div>
                                                        {/* Render pharmacy.opening_hours dynamically */}
                                                        {(() => {
                                                            let timings = [];
                                                            try {
                                                                if (
                                                                    pharmacy.opening_hours &&
                                                                    pharmacy.opening_hours !== "null"
                                                                ) {
                                                                    timings = JSON.parse(pharmacy.opening_hours);
                                                                }
                                                            } catch (e) {
                                                                timings = [];
                                                            }
                                                            // Fallback to default days if timings is empty
                                                            const weekDays = [
                                                                "Monday",
                                                                "Tuesday",
                                                                "Wednesday",
                                                                "Thursday",
                                                                "Friday",
                                                                "Saturday",
                                                                "Sunday"
                                                            ];
                                                            // If timings is not an array or empty, show all closed
                                                            if (!Array.isArray(timings) || timings.length === 0) {
                                                                return weekDays.map((day, idx) => (
                                                                    <div className="store-time-tags" key={day}>
                                                                        <div className="store-days">{day}</div>
                                                                        <div className="store-times">
                                                                            <span className="store-close">CLOSED</span>
                                                                        </div>
                                                                    </div>
                                                                ));
                                                            }
                                                            // Map timings to UI
                                                            return weekDays.map((day, idx) => {
                                                                // Find the timing object for this day
                                                                const timing = timings.find(
                                                                    t =>
                                                                        (t.week && t.week.toLowerCase() === day.toLowerCase())
                                                                );
                                                                let open = timing && timing.open ? timing.open : "00:00";
                                                                let close = timing && timing.close ? timing.close : "00:00";
                                                                // If both open and close are "00:00", treat as closed
                                                                const isClosed =
                                                                    (!timing || (open === "00:00" && close === "00:00"));
                                                                // Format time to 12-hour with am/pm
                                                                function formatTime(timeStr) {
                                                                    if (!timeStr || timeStr === "00:00") return "00:00 am";
                                                                    const [hourStr, minStr] = timeStr.split(":");
                                                                    let hour = parseInt(hourStr, 10);
                                                                    const min = minStr;
                                                                    const ampm = hour >= 12 ? "pm" : "am";
                                                                    hour = hour % 12;
                                                                    if (hour === 0) hour = 12;
                                                                    return `${hour}:${min} ${ampm}`;
                                                                }
                                                                return (
                                                                    <div className="store-time-tags" key={day}>
                                                                        <div className={`store-days${(new Date().toLocaleString('en-US', { weekday: 'long' }) === day) ? " current_day" : ""}`}>{day}</div>
                                                                        <div className="store-times">
                                                                            {isClosed ? (
                                                                                <span className="store-close">CLOSED</span>
                                                                            ) : (
                                                                                <span className="store-open">
                                                                                    {formatTime(open)} - {formatTime(close)}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            });
                                                        })()}
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>

                                        <div className="store-social-wrapper">
                                            <ul className="store-social">
                                            <li>
                                                <a href="#" target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-facebook-square"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank" rel="noopener noreferrer">
                                                <i className="fab fa-fa-brands fa-square-x-twitter"></i>
                                                </a>
                                            </li>
                                            </ul>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>

                                <div className="dokan-store-tabs">
                                <ul className="dokan-modules-button"></ul>
                                <ul className="dokan-list-inline">
                                    <li>
                                    <a href="//amentotech.com/projects/doctreat/store/pharmatech/">Products</a>
                                    </li>
                                    <li>
                                    <a href="//amentotech.com/projects/doctreat/store/pharmatech/toc">Terms and Conditions</a>
                                    </li>
                                </ul>
                                </div>
                            </div>

                            <div className="dokan-store-products-filter-area dokan-clearfix">
                                <form className="dokan-store-products-ordeby" method="get">
                                <input 
                                    type="text" 
                                    name="product_name" 
                                    className="product-name-search dokan-store-products-filter-search" 
                                    placeholder="Enter product name" 
                                    autoComplete="off" 
                                    data-store_id="194" 
                                />
                                <div id="dokan-store-products-search-result" className="dokan-ajax-store-products-search-result"></div>
                                <input type="submit" name="search_store_products" className="search-store-products dokan-btn-theme" value="Search" />

                                <select 
                                    name="product_orderby" 
                                    className="orderby orderby-search" 
                                    aria-label="Shop order" 
                                    onChange={(e) => {
                                    if(e.target.value !== "0") {
                                        e.target.form.submit();
                                    }
                                    }}
                                >
                                    <option value="menu_order">Default sorting</option>
                                    <option value="popularity" selected>Sort by popularity</option>
                                    <option value="rating">Sort by average rating</option>
                                    <option value="date">Sort by latest</option>
                                    <option value="price">Sort by price: low to high</option>
                                    <option value="price-desc">Sort by price: high to low</option>
                                </select>
                                <input type="hidden" name="paged" value="1" />
                                </form>
                            </div>
                            
                            <div className="seller-items">
                                <ul className="products columns-4">
                                <li className="product type-product post-1479 status-publish first instock product_cat-hoodies has-post-thumbnail shipping-taxable purchasable product-type-simple">
                                    <a href="//amentotech.com/projects/doctreat/product/hoodie-with-logo/" className="woocommerce-LoopProduct-link woocommerce-loop-product__link">
                                    <img 
                                        fetchPriority="high" 
                                        width="300" 
                                        height="300" 
                                        src="//amentotech.com/projects/doctreat/wp-content/uploads/2019/01/hoodie-with-logo-2-300x300.jpg" 
                                        className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" 
                                        alt="Hoodie with Logo" 
                                        decoding="async" 
                                        srcSet="//amentotech.com/projects/doctreat/wp-content/uploads/2019/01/hoodie-with-logo-2-300x300.jpg 300w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/hoodie-with-logo-2-100x100.jpg 100w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/hoodie-with-logo-2-600x600.jpg 600w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/hoodie-with-logo-2-150x150.jpg 150w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/hoodie-with-logo-2-768x768.jpg 768w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/hoodie-with-logo-2-65x65.jpg 65w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/hoodie-with-logo-2-30x30.jpg 30w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/hoodie-with-logo-2-20x20.jpg 20w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/hoodie-with-logo-2.jpg 801w" 
                                        sizes="(max-width: 300px) 100vw, 300px" 
                                    />
                                    <h2 className="woocommerce-loop-product__title">Hoodie with Logo</h2>
                                    <span className="price">
                                        <span className="woocommerce-Price-amount amount">
                                        <bdi>
                                            <span className="woocommerce-Price-currencySymbol">$</span>45.00
                                        </bdi>
                                        </span>
                                    </span>
                                    </a>
                                    <a 
                                    href="?add-to-cart=1479" 
                                    aria-describedby="woocommerce_loop_add_to_cart_link_describedby_1479" 
                                    data-quantity="1" 
                                    className="button product_type_simple add_to_cart_button ajax_add_to_cart" 
                                    data-product_id="1479" 
                                    data-product_sku="woo-hoodie-with-logo" 
                                    aria-label="Add to cart: Hoodie with Logo" 
                                    rel="nofollow" 
                                    data-success_message="Hoodie with Logo has been added to your cart"
                                    >
                                    Add to cart
                                    </a>
                                    <span id="woocommerce_loop_add_to_cart_link_describedby_1479" className="screen-reader-text"></span>
                                </li>

                                <li className="product type-product post-11 status-publish instock product_cat-accessories has-post-thumbnail sale shipping-taxable purchasable product-type-simple">
                                    <a href="//amentotech.com/projects/doctreat/product/belt/" className="woocommerce-LoopProduct-link woocommerce-loop-product__link">
                                    <span className="onsale">Sale!</span>
                                    <img 
                                        width="300" 
                                        height="300" 
                                        src="//amentotech.com/projects/doctreat/wp-content/uploads/2019/01/belt-2-300x300.jpg" 
                                        className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" 
                                        alt="Belt" 
                                        decoding="async" 
                                        srcSet="//amentotech.com/projects/doctreat/wp-content/uploads/2019/01/belt-2-300x300.jpg 300w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/belt-2-100x100.jpg 100w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/belt-2-600x600.jpg 600w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/belt-2-150x150.jpg 150w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/belt-2-768x768.jpg 768w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/belt-2-65x65.jpg 65w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/belt-2-30x30.jpg 30w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/belt-2-20x20.jpg 20w, //amentotech.com/projects/doctreat/wp-content/uploads/2019/01/belt-2.jpg 801w" 
                                        sizes="(max-width: 300px) 100vw, 300px" 
                                    />
                                    <h2 className="woocommerce-loop-product__title">Belt</h2>
                                    <span className="price">
                                        <del aria-hidden="true">
                                        <span className="woocommerce-Price-amount amount">
                                            <bdi>
                                            <span className="woocommerce-Price-currencySymbol">$</span>65.00
                                            </bdi>
                                        </span>
                                        </del>
                                        <span className="screen-reader-text">Original price was: $65.00.</span>
                                        <ins aria-hidden="true">
                                        <span className="woocommerce-Price-amount amount">
                                            <bdi>
                                            <span className="woocommerce-Price-currencySymbol">$</span>55.00
                                            </bdi>
                                        </span>
                                        </ins>
                                        <span className="screen-reader-text">Current price is: $55.00.</span>
                                    </span>
                                    </a>
                                    <a 
                                    href="?add-to-cart=11" 
                                    aria-describedby="woocommerce_loop_add_to_cart_link_describedby_11" 
                                    data-quantity="1" 
                                    className="button product_type_simple add_to_cart_button ajax_add_to_cart" 
                                    data-product_id="11" 
                                    data-product_sku="woo-belt" 
                                    aria-label="Add to cart: Belt" 
                                    rel="nofollow" 
                                    data-success_message="Belt has been added to your cart"
                                    >
                                    Add to cart
                                    </a>
                                    <span id="woocommerce_loop_add_to_cart_link_describedby_11" className="screen-reader-text"></span>
                                </li>
                                </ul>
                            </div>

                            <nav role="navigation" id="nav-below" className="site-navigation paging-navigation">
                                <ul className="pager"></ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </main>
    )}

    </>
    
  );
};

export default PharmacyDetailes;
